import React from 'react';
import NewsletterMembers from './newsletter/NewsletterMembers';
import TestZone from './tests/TestZone';
import DevScripting from './tests/DevScripting';

class Admin_Dev extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedSection: null
    };
  }

  renderComponent() {
    const { selectedSection } = this.state;
    if (selectedSection === 'newsletter') return <NewsletterMembers />;
    if (selectedSection === 'test') return <TestZone />;
    if (selectedSection === 'dev') return <DevScripting />;
    return null;
  }

  render() {
    return (
      <div>
        <h3>*** Développeurs ***</h3><br/>

        <div className="row">
        <div className="col-12 col-md-3">
          <button type="button" className="btn btn-primary btn-masterOptions" 
						onClick={() => this.setState({ selectedSection: 'newsletter' })}>Membres infolettre</button>
          <button type="button" className="btn btn-primary btn-masterOptions" 
						onClick={() => this.setState({ selectedSection: 'test' })}>Test Zone</button>
          <button type="button" className="btn btn-primary btn-masterOptions" 
						onClick={() => this.setState({ selectedSection: 'dev' })}>Dev Scripts</button>
        </div>
        </div>
        <hr/>

        <div style={{ marginTop: '20px' }}>
          {this.renderComponent()}
        </div>
      </div>
    );
  }
}

export default Admin_Dev;
